import { FormattedMessage } from "react-intl";
import useTermOptDeadline from "../useTermOptDeadline.tsx";

export default function DaysRemainingMessage() {
  const { optDeadline } = useTermOptDeadline();

  if (!optDeadline) {
    return null;
  }

  return (
    <FormattedMessage
      defaultMessage={
        "You have until <strong>{date, date, long}</strong> to finalize your program decision."
      }
      values={{
        date: new Date(optDeadline),
        strong: (content) => <strong>{content}</strong>,
      }}
    />
  );
}
